import React from "react";
import { FormGroup } from "react-bootstrap";
import { DEFAULT_COLOR_ACCENT, FONT } from "../../../constants";
import * as constants from '../../constants';
import CPSettingFont from "../../../../../UI/Settings/CPSettingFont";
import CPSettingSize from "../../../../../UI/Settings/CPSettingSize";
import CPSettingColor from "../../../../../UI/Settings/CPSettingColor";
import CPSettingToggle from "../../../../../UI/Settings/CPSettingToggle";

const TextSettings = ({eventSettings, onChange}) => {
    return (
        <>
            <CPSettingFont
                font={eventSettings?.[FONT]}
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.WIDGET_TITLE_COLOR}
                label="Цвет текста в заголовке"
                eventColor={eventSettings?.[constants.WIDGET_TITLE_COLOR]}
                defaultColor="#16161B"
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_TITLE_SIZE}
                label="Размер текста в заголовке"
                eventValue={eventSettings?.[constants.WIDGET_TITLE_SIZE]}
                defaultValue={'24px'}
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.WIDGET_SUBTITLE_COLOR}
                label="Цвет текста в подзаголовке"
                eventColor={eventSettings?.[constants.WIDGET_SUBTITLE_COLOR]}
                defaultColor="#3A3A3A"
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_SUBTITLE_SIZE}
                label="Размер текста в подзаголовке"
                eventValue={eventSettings?.[constants.WIDGET_SUBTITLE_SIZE]}
                defaultValue={'24px'}
                onChange={onChange}
            />
            <div style={{display: 'flex', alignItems: 'center', columnGap: '20px'}}>
                <FormGroup>Текст над полями: </FormGroup>
                <CPSettingToggle
                    name={constants.WIDGET_FIRST_SCREEN_LABELS_HIDDEN}
                    isChecked={eventSettings?.[constants.WIDGET_FIRST_SCREEN_LABELS_HIDDEN]}
                    label="Скрывать"
                    onChange={onChange}
                />
            </div>
            {!eventSettings?.[constants.WIDGET_FIRST_SCREEN_LABELS_HIDDEN] && (
                <>
                    <CPSettingColor
                        name={constants.WIDGET_INPUT_LABEL_COLOR}
                        label="Цвет текста над полями"
                        eventColor={eventSettings?.[constants.WIDGET_INPUT_LABEL_COLOR]}
                        defaultColor="#3A3A3A"
                        onChange={onChange}
                    />
                    <CPSettingSize
                        name={constants.WIDGET_INPUT_LABEL_SIZE}
                        label="Размер текста над полями"
                        eventValue={eventSettings?.[constants.WIDGET_INPUT_LABEL_SIZE]}
                        defaultValue={'12px'}
                        onChange={onChange}
                    />
                </>
            )}
            <div style={{display: 'flex', alignItems: 'center', columnGap: '12px'}}>
                <FormGroup>Плейсхолдеры:</FormGroup>
                <CPSettingToggle
                    name={constants.WIDGET_FIRST_SCREEN_PLACEHOLDERS_HIDDEN}
                    isChecked={eventSettings?.[constants.WIDGET_FIRST_SCREEN_PLACEHOLDERS_HIDDEN]}
                    label="Скрывать"
                    onChange={onChange}
                />
            </div>
            {!eventSettings?.[constants.WIDGET_FIRST_SCREEN_PLACEHOLDERS_HIDDEN] && (
                <>
                    <CPSettingColor
                        name={constants.WIDGET_PLACEHOLDER_COLOR}
                        label="Цвет плейсхолдеров"
                        defaultColor="#A9A9AB"
                        eventColor={eventSettings?.[constants.WIDGET_PLACEHOLDER_COLOR]}
                        onChange={onChange}
                    />
                    <CPSettingSize
                        name={constants.WIDGET_PLACEHOLDER_SIZE}
                        label="Размер текста в плейсхолдерах"
                        eventValue={eventSettings?.[constants.WIDGET_PLACEHOLDER_SIZE]}
                        defaultValue={'16px'}
                        onChange={onChange}
                    />
                </>
            )}
            <CPSettingColor
                name={constants.WIDGET_INPUT_TEXT_COLOR}
                label="Цвет введённого текста в инпут"
                eventColor={eventSettings?.[constants.WIDGET_INPUT_TEXT_COLOR]}
                defaultColor="#16161B"
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.WIDGET_INPUT_ERROR_BORDER_COLOR}
                label="Цвет ошибки - контур полей и предупреждение внизу"
                eventColor={eventSettings?.[constants.WIDGET_INPUT_ERROR_BORDER_COLOR]}
                defaultColor={DEFAULT_COLOR_ACCENT}
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.WIDGET_INPUT_ERROR_MESSAGE_COLOR}
                label="Цвет ошибки -  текст внутри  поля с ошибкой"
                eventColor={eventSettings?.[constants.WIDGET_INPUT_ERROR_MESSAGE_COLOR]}
                defaultColor="#FFFFFF"
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.WIDGET_CHECKBOX_TEXT_COLOR}
                label="Цвет текста в полях с чек-боксом"
                eventColor={eventSettings?.[constants.WIDGET_CHECKBOX_TEXT_COLOR]}
                defaultColor="#3A3A3A"
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_CHECKBOX_TEXT_SIZE}
                label="Размер текста в полях с чек-боксом"
                eventValue={eventSettings?.[constants.WIDGET_CHECKBOX_TEXT_SIZE]}
                defaultValue={'16px'}
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_CHECKBOX_SIZE}
                label="Размер чек-бокса"
                eventValue={eventSettings?.[constants.WIDGET_CHECKBOX_SIZE]}
                defaultValue={'16px'}
                onChange={onChange}
            />
            <CPSettingColor
                name={constants.WIDGET_DISCLAIMER_TEXT_COLOR}
                label="Цвет текста в дисклеймере"
                eventColor={eventSettings?.[constants.WIDGET_DISCLAIMER_TEXT_COLOR]}
                defaultColor="#3A3A3A"
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.WIDGET_DISCLAIMER_TEXT_SIZE}
                label="Размер текста в дисклеймере"
                eventValue={eventSettings?.[constants.WIDGET_DISCLAIMER_TEXT_SIZE]}
                defaultValue={'14px'}
                onChange={onChange}
            />
        </>
    );
};

export default TextSettings;
